import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function getAdminListApi(tax_id) {
    try {
        const resp = await api.get(`${baseURL}/super-admin/getAdmin/${tax_id}`);

        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function createAdminApi(admin) {
    try {
        const resp = await api.post(`${baseURL}/super-admin/insertAdmin`, admin);
        
        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function updateAdminApi(adminId, admin) {
    try {
        const resp = await api.put(`${baseURL}/super-admin/updateAdmin/${adminId}`, admin);

        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function deleteAdminApi(_id) {
    try {
        const resp = await api.delete(`${baseURL}/super-admin/deleteAdmin/${_id}`);

        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function getDashboardDataApi(search, startDate, endDate) {
    try {
        const resp = await api.get(`${baseURL}/invoice/dashboard?search=${search}&startDate=${startDate}&endDate=${endDate}`);
        
        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

const AdminListApi = {
    getAdminListApi,
    createAdminApi,
    updateAdminApi,
    deleteAdminApi,
    getDashboardDataApi    
};
export default AdminListApi;